import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { DividerVerticalIcon } from "@radix-ui/react-icons";
import { memo } from "react";

interface ExamplePromptsProps {
  examplePrompts: string[];
  isDisabled?: boolean;
  onExamplePromptSelected: (examplePrompt: string) => void;
}

const ExamplePrompts = memo(
  ({
    examplePrompts,
    isDisabled,
    onExamplePromptSelected,
  }: ExamplePromptsProps) => {
    return (
      <div className="md:col-span-4 md:col-start-2 md:flex md:justify-center">
        <div className="w-full z-10 px-6 md:pt-3 md:grid md:grid-cols-3 space-y-2 md:space-y-0">
          {examplePrompts.map((examplePrompt, index) => (
            <div className="flex flex-row items-center" key={examplePrompt}>
              <Card
                className={cn(
                  "md:h-auto grow text-sm overflow-hidden dark:bg-transparent dark:hover:bg-shallow hover:bg-destructive-foreground hover:cursor-pointer border md:border-none shadow-sm md:shadow-none",
                  isDisabled && "hover:border-border hover:cursor-not-allowed",
                )}
                onClick={() => {
                  onExamplePromptSelected(examplePrompt);
                }}
              >
                <CardContent className="px-4 py-2 md:text-center">
                  <p>{examplePrompt}</p>
                </CardContent>
              </Card>
              {index < examplePrompts.length - 1 && (
                <DividerVerticalIcon className="hidden md:block size-6 text-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  },
);

ExamplePrompts.displayName = "ExamplePrompts";

export default ExamplePrompts;
